var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ghh-button",class:[
    ("ghh-button--" + _vm.type),
    {
      'is-disabled': _vm.disabled,
    } ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" this is button ")])}
var staticRenderFns = []

export { render, staticRenderFns }